var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 311,
    viewBox: "0 0 1440 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -17,
    y: 5.75928,
    width: 1474,
    height: 305.24,
    rx: 12,
    fill: "url(#paint0_linear_2298_4348)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2298_4348",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 890,
    y: 0,
    width: 600,
    height: 306
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 890,
    width: 599.184,
    height: 305.24,
    rx: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2298_4348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1410.58 174.424C1456.21 87.7297 1471.33 32.7959 1444.38 -13.1234C1438.5 -23.1229 1432.56 -30.5788 1426.32 -36.6316C1403.89 -58.4052 1377.75 -62.0457 1337.82 -100.816C1297.86 -139.612 1292.58 -166.478 1270.18 -188.223C1263.96 -194.27 1256.41 -199.919 1246.42 -205.322C1200.48 -230.166 1148.84 -210.693 1068.85 -157.352C988.819 -104.059 946.578 -50.4711 958.435 -21.3006C960.362 -16.5498 963.104 -12.5556 966.535 -9.22385C984.164 7.89171 1020.14 7.52697 1058.47 2.9739C1102.12 -2.18928 1107.97 2.23637 1171.48 63.9041L1191.27 83.1097C1254.77 144.764 1259.43 150.547 1257.48 196.191C1255.76 236.282 1257.91 273.607 1275.54 290.724C1278.98 294.058 1282.98 296.643 1287.67 298.318C1316.46 308.609 1364.93 261.108 1410.58 174.424ZM1131.08 -75.0707C1113.5 -92.1437 1111.81 -120.076 1127.33 -137.376C1142.84 -154.657 1169.78 -154.863 1187.37 -137.79C1204.96 -120.705 1206.62 -92.7375 1191.11 -75.4567C1175.58 -58.1561 1148.68 -57.9852 1131.08 -75.0707ZM1285.38 45.8698C1276.39 37.1455 1275.47 22.8945 1283.34 14.1212C1291.21 5.34624 1304.94 5.32949 1313.93 14.0529C1322.97 22.8348 1323.9 37.0811 1316.03 45.856C1308.15 54.6302 1294.42 54.6516 1285.38 45.8698ZM1289.91 115.218C1280.93 106.494 1279.98 92.3151 1287.83 83.56C1295.75 74.732 1309.42 74.7478 1318.4 83.4721C1327.46 92.2657 1328.42 106.449 1320.5 115.277C1312.64 124.033 1298.97 124.012 1289.91 115.218ZM1352.27 45.739C1343.28 37.0148 1342.36 22.8024 1350.23 14.0275C1358.11 5.2494 1371.82 5.21454 1380.8 13.9388C1389.86 22.7325 1390.78 36.9669 1382.9 45.7442C1375.03 54.5199 1361.32 54.5327 1352.27 45.739ZM1356.78 115.196C1347.76 106.435 1346.85 92.201 1354.72 83.4276C1362.6 74.6527 1376.31 74.617 1385.33 83.3791C1394.32 92.1041 1395.23 106.332 1387.35 115.107C1379.48 123.881 1365.77 123.921 1356.78 115.196Z",
    fill: "url(#paint1_linear_2298_4348)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2298_4348",
    x1: 461.748,
    y1: 5.75928,
    x2: 1019.91,
    y2: 164.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2298_4348",
    x1: 1422.38,
    y1: 199.113,
    x2: 1167.94,
    y2: -28.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0400508,
    stopColor: "#FAFF00",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E800",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.5eea9604aa347366d21a6bde979e2c5c.svg";
export { ForwardRef as ReactComponent };